import { Controller } from "react-hook-form"
import { FormText, Input } from "reactstrap"

const SelectShowroomListbox = ({ user, control }) => {
  return (
    <Controller
      name="showroomId"
      id="showroomId"
      control={control}
      render={({ field }) => {
        if (user.showrooms?.length > 1) {
          return (
            <>
              <Input {...field} type="select" defaultValue={user.showroomId}>
                {user.showrooms?.map((showroom) => (
                  <option key={showroom.institutionId} value={showroom.institutionId}>
                    {showroom.name}
                  </option>
                ))}
              </Input>
              <FormText className="text-muted">
                Change your default showroom in <a href="/Manage">your profile</a>.
              </FormText>
            </>
          )
        } else {
          return <Input {...field} type="hidden" value={user.showroomId} />
        }
      }}
    />
  )
}

export default SelectShowroomListbox
